import { object, string } from "yup";

export const regionSchema = object({
  id: string().optional().nullable(),
  name: string().max(255).required().label("Region Name"),
  code: string().max(255).required().label("Region Code"),
  description: string().min(0).max(1024).optional().label("Description"),
});
